import React, { useState, useEffect, createRef, useRef } from 'react';
import cx from 'classnames';

import {
  Button,
  Input,
  Navigation,
  KeyboardNav,
} from '../../../../../components/shared';

import styles from '../../../Forms.scss';
import stylesForm from '../../../../../components/shared/Form/Form.scss';

const ReqInfo = ({ navigation, step, index }) => {
  const { next, previous } = navigation;
  const [value, setValue] = useState(false);

  return (
    <>
      <h4>
        <span>{index + 1}</span> Terms & Conditions
      </h4>
      <div className={styles.terms}>
        <div className={styles.terms__wrapper}>
          <div className={styles.terms__content}>
            <h3>Background</h3>
            <p>
              The property (house and garage) at 367 Addison Avenue is the
              central part of the Hewlett-Packard Company Archives, LLC.
              Employees of Hewlett Packard Enterprise and HP Inc. may request a
              visit or event by completing this request form.
            </p>
            <h3>Instructions</h3>
            <p>
              Once your request is approved, you will receive a calendar invite
              and e-mail confirmation for your records. Please allow
              approximately 72 business hours to fully schedule your request, as
              this time is needed to confirm a tour guide.
            </p>
            <h3>Hours of Operation</h3>
            <p>
              Monday, Tuesday, Wednesday, Friday: 9:00am - 8:00pm
              <br />
              Thursday: 1:00pm - 8:00pm
            </p>
            <ul>
              <li>
                If the requested date is already booked, you may reach out to
                the other party to request a change. There is no guarantee of a
                change.
              </li>
              <li>
                Additional closures may occur throughout the year for major
                maintenance projects or other needs. These dates will be
                communicated as they arise.
              </li>
              <li>
                The upstairs apartment is CLOSED to the public. There is no
                access to this private property.
              </li>
            </ul>
            <h3> Group Sizes</h3>
            <p>
              The recommended maximum group size for a tour is 15–20 people.
              Groups larger than 20 may be divided into two separate tours. *
            </p>
            <h3>Additional Terms and Conditions</h3>
            <ul>
              <li>
                Requests can be made by employees of Hewlett Packard Enterprise
                or HP Inc.
              </li>
              <li>Requests are managed on a first-come, first-served basis.</li>
              <li>
                Customer visits/events take priority and should be focused on
                top accounts.
              </li>
              <li>Requests should be made at least two weeks in advance.</li>
              <li>
                Staff events should be limited to events sponsored by a Manager
                at Level 3, or above. (CEO of each company being Level 0).
              </li>
              <li>
                All associated costs are billed back to the requesting
                organization. <br />
                (Examples are – but not limited to – additional security,
                non-standard hours’ security, cleaning, food and beverage
                services, damage)
                <ul>
                  <li>
                    Funds may be remitted to the bank account of the
                    Hewlett-Packard Company Archives, LLC (details provided upon
                    request) or by credit card.
                  </li>
                  <li>
                    Catering costs and transportation fees are paid to the
                    vendors directly by the requesting organization.
                  </li>
                </ul>
              </li>
              <li>
                The Addison Avenue Property is a non-smoking location.
                <ul>
                  <li>
                    The no smoking policy applies to the property, the sidewalk
                    and street in front of the house and the sidewalk and street
                    in front of the neighbors.
                  </li>
                </ul>
              </li>
              <li>
                Transportation is the responsibility of the requester. Addison
                Avenue is a residential street and parking is at a premium.
                <ul>
                  <li>
                    Groups of fewer than 6 people (two vehicles or fewer) are
                    required to use carpooling or rideshare services such as
                    Lyft.
                  </li>
                  <li>
                    For groups of 6 or more, contact ABC Transportation
                    (www.abctrans.com) to schedule transport from the HPE or HPI
                    site to Addison Avenue and back.
                  </li>
                </ul>
              </li>
              <li>
                Catering requests must be made at least two weeks in advance of
                the event. The requesting company/team from HPE or HPI is
                responsible for securing catering services. Preferred caterers
                are:
                <ul>
                  <li>
                    Handheld Catering through An Bui at{' '}
                    <a href="mailto:an@handheldcatering.com">
                      an@handheldcatering.com
                    </a>
                  </li>
                  <li>
                    Cuisine Style through Pamela Keith (Owner/Operator) at
                    650.888.8720
                  </li>
                  <li>
                    Macarena through Matxalen Aketxe at{' '}
                    <a href="mailto:maketxe@macarenarestaurant.com">
                      maketxe@macarenarestaurant.com
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                Once catering needs are determined, the requester is responsible
                for finalizing the catering costs, menus, and plans.
              </li>
              <li>
                All damages are the financial responsibility of the requester.
              </li>
            </ul>
            <h3>Escalation</h3>
            <p>
              If you have an urgent question or change to your request, please
              note “URGENT: ESCALATION” in the e-mail subject line. When
              scheduling an escalation, please allow up to 24 business hours for
              a response from the Addison Avenue Scheduling Team.
            </p>
            <h3>Responsibilities for the Day of the Visit</h3>
            <ul>
              <li>
                The Addison Avenue Scheduling Team will communicate instructions
                regarding site access/security to the requester, once the event
                is scheduled and added to the Addison Avenue Calendar.
              </li>
              <li>There is a public and private network available for use.</li>
              <li>
                Visits/Events must be accompanied by a named representative of
                Hewlett Packard Enterprise or HP Inc., depending on the company
                of the requester.
                <ul>
                  <li>
                    This representative will be a trained tour guide, assigned
                    by the Addison Avenue Scheduling Team.
                  </li>
                  <li>
                    Tour Guide information and instructions are provided to
                    appropriate parties under separate cover.
                  </li>
                </ul>
              </li>
              <li>
                Once the event concludes, the responsible party will complete a
                final walk-through, and notify security of departure at
                916.785.4919.
              </li>
            </ul>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
      <div className={cx(stylesForm.checkbox__small, stylesForm.full)}>
        <input
          type="checkbox"
          id="terms"
          name="terms"
          checked={value}
          onChange={() => setValue(!value)}
        />
        <label htmlFor="terms">I agree to the terms outlined above.</label>
      </div>

      <Navigation navigation={navigation} isValid={value} />
    </>
  );
};

export default ReqInfo;
